import { faShieldCheck, faShieldExclamation, faShieldSlash, faShield } from '@fortawesome/pro-solid-svg-icons';

const CONTENT_RATING = {
    DEFAULT: "DEFAULT",  
    SAFE: "SAFE",        
    EROTIC: "EROTIC",       
    EXPLICIT: "EXPLICIT",    
    EXTREM: "EXTREM"
};

const CONTENT_RATING_LEVEL = {
    [CONTENT_RATING.DEFAULT]: 0,  // Non traité
    [CONTENT_RATING.SAFE]: 1,         // Safe (+16)
    [CONTENT_RATING.EROTIC]: 2,       // Érotique (+18)
    [CONTENT_RATING.EXPLICIT]: 3,     // Explicite
    [CONTENT_RATING.EXTREM]: 4,      // Extrême
};

const CONTENT_RATING_ICON = {
    [CONTENT_RATING.SAFE]: faShieldCheck,         // Safe (+16)
    [CONTENT_RATING.EROTIC]: faShield,       // Érotique (+18)
    [CONTENT_RATING.EXPLICIT]: faShieldExclamation,     // Explicite
    [CONTENT_RATING.EXTREM]: faShieldSlash,      // Extrême
};

const CONTENT_RATINGS_LIST = [
    {
        label : CONTENT_RATING.SAFE,
        value : CONTENT_RATING_LEVEL[CONTENT_RATING.SAFE],
        icon : CONTENT_RATING_ICON[CONTENT_RATING.SAFE],
        className : "safe",
    },
    {
        label : CONTENT_RATING.EROTIC,
        value : CONTENT_RATING_LEVEL[CONTENT_RATING.EROTIC],
        icon : CONTENT_RATING_ICON[CONTENT_RATING.EROTIC],
        className : "erotic",
    },
    {
        label : CONTENT_RATING.EXPLICIT,
        value : CONTENT_RATING_LEVEL[CONTENT_RATING.EXPLICIT],
        icon : CONTENT_RATING_ICON[CONTENT_RATING.EXPLICIT],
        className : "explicit",
    },
    {
        label : CONTENT_RATING.EXTREM,
        value : CONTENT_RATING_LEVEL[CONTENT_RATING.EXTREM],
        icon : CONTENT_RATING_ICON[CONTENT_RATING.EXTREM],
        className : "extrem",
    }
];

const CONTENT_RATINGS_MAP = {
    [CONTENT_RATING_LEVEL.SAFE] : {
        label : "SFW",
        icon : CONTENT_RATING_ICON[CONTENT_RATING.SAFE]
    },
    [CONTENT_RATING_LEVEL.EROTIC] :{
        label : "SFW",
        icon : CONTENT_RATING_ICON[CONTENT_RATING.SAFE]
    },
    [CONTENT_RATING_LEVEL.EXPLICIT] :{
        label : "NSFW",
        icon : CONTENT_RATING_ICON[CONTENT_RATING.EXPLICIT]
    },
    [CONTENT_RATING_LEVEL.EXTREM] :{
        label : "Contenu sensible",
        icon : CONTENT_RATING_ICON[CONTENT_RATING.EXTREM]
    }
}

export {
    CONTENT_RATING,
    CONTENT_RATING_LEVEL,
    CONTENT_RATINGS_LIST,
    CONTENT_RATING_ICON,
    CONTENT_RATINGS_MAP
}